import { put, select } from 'redux-saga/effects';
import {
  getDiagnosisDTContext,
  getServiceDTContext,
} from './common-decision-tree-logic-saga';
import {
  allDTServiceSelector,
  currentCheckUpServiceSelector,
  diagnosisPathSelector,
  diagnosisResultSelector,
  localDecisionTreeSelector,
} from 'redux/selectors/localDecisionTree';
import caseCreationActions from 'redux/actions/caseCreationActions';
import { caseCreationEditModeSelector } from 'redux/selectors/caseCreation';
import { push } from 'connected-react-router';
import routes from 'Routes/routesConfig';
import { moveToNextStep } from 'redux/actions/stepActions';
import { selectDTOption } from 'redux/selectors/config';

export function* finishDTSaga() {
  const {
    result: { code, dropout },
  } = yield saveDecisionTreeData();
  const isEditMode = yield select(caseCreationEditModeSelector);
  if (isEditMode) {
    return;
  }
  if (code === 'DROPOFF_INSTANT' || dropout === 'instant') {
    yield put(push(routes.EXCLUDED));
  } else {
    yield put(moveToNextStep());
  }
}

function* saveDecisionTreeData() {
  const { questions, ...result } = yield select(diagnosisResultSelector);
  const diagnosisPath = yield select(diagnosisPathSelector);
  const rawServices = yield select(allDTServiceSelector);
  const dtOption = yield select(selectDTOption);
  const checkUpService = yield select(currentCheckUpServiceSelector);
  const { services: serviceResults } = yield select(localDecisionTreeSelector);
  const diagnosisContextQuestions = yield getDiagnosisDTContext();
  const serviceContextQuestions = yield getServiceDTContext();
  const diagnosisContextQuestionsByDtOption =
    dtOption === 'etl' ? [] : diagnosisContextQuestions;
  const diagnosisPathByDtOption =
    dtOption === 'etl'
      ? diagnosisPath.map(({ questionText, answerText }) => ({
          id: questionText,
          value: answerText,
        }))
      : diagnosisPath.map(({ id, value }) => ({ id, value }));

  const services = rawServices.map(service => ({
    service_code: service,
    questions_and_answers: [
      ...serviceContextQuestions.map(contextQuestion =>
        contextQuestion.id === 'SERVICES'
          ? { id: 'SERVICES', value: service }
          : contextQuestion,
      ),
      ...(serviceResults[service]?.actualPath || {}),
    ],
    is_check_up: !!serviceResults[service].is_check_up,
  }));

  const decisionTree = {
    result: {
      ...result,
      code: result.code || result.status,
      isSoftFix: result.isSoftFix,
      checkUp: services.some(service => service.is_check_up),
      questions: {
        diagnosis: (questions || []).filter(question => question),
        services: Object.values(serviceResults)
          .flatMap(({ questions }) => questions)
          .filter(question => question),
      },
    },
    optionPath: [
      ...diagnosisContextQuestionsByDtOption,
      ...diagnosisPathByDtOption,
    ],
    services,
    checkUpService,
  };
  const { updateCCDecisionTree } = caseCreationActions;
  yield put(updateCCDecisionTree({ decisionTree }));
  return decisionTree;
}
